import { Reducer } from 'redux';

import {
  GroupActivitySummaryLoadFulfilledAction,
  GroupActivitySummaryLoadPendingAction,
  GroupActivitySummaryLoadRejectedAction,
} from '../../domains/groupActivitySummary/actions.types';
import { moveToFulfilled, moveToPending, moveToRejected } from '../types';

import { GroupActivitySummaries } from './types';

export type GroupActivitySummaryAction =
  | GroupActivitySummaryLoadFulfilledAction
  | GroupActivitySummaryLoadPendingAction
  | GroupActivitySummaryLoadRejectedAction;

const initialState: GroupActivitySummaries = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<GroupActivitySummaries, GroupActivitySummaryAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'GROUP_ACTIVITY_SUMMARY.LOAD_PENDING':
      return moveToPending(state, [action.payload.groupId]);
    case 'GROUP_ACTIVITY_SUMMARY.LOAD_REJECTED':
      return moveToRejected(state, [action.payload.groupId], action.payload.error);
    case 'GROUP_ACTIVITY_SUMMARY.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groupActivitySummaries);
    default:
      return state;
  }
};

export default reducer;
